import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { openSMLUpgradePrompt } from '../../../redux/slices/appInfo/slice';
import { SMLUpgradeFeature } from '../config/music24PlanCapabilities';

/**
 * Opens the global upgrade modal for a feature a locked control just refused.
 *
 * A plain dispatch, not `useUpgradeOffer`: a locked control only needs to name what the person
 * hit and let the modal (`GlobalSMLUpgradeModal`) take it from there — it does not need the
 * modal's own pricing/checkout state.
 */
export function useUpgradePrompt(): (feature: SMLUpgradeFeature, subject?: string) => void {
  const dispatch = useDispatch();
  return useCallback(
    (feature: SMLUpgradeFeature, subject?: string) => dispatch(openSMLUpgradePrompt({ feature, subject })),
    [dispatch]
  );
}
